import { PopoverCore } from "../popover/core.js";
//#region src/core/ui/volume-popover/core.ts
/**
* A volume-aware popover that preserves its mute trigger when volume level controls are unavailable.
*
* @internal
*/
var VolumePopoverCore = class extends PopoverCore {
	static defaultProps = PopoverCore.defaultProps;
	#media = null;
	setMedia(media) {
		this.#media = media;
	}
	getState() {
		const availability = this.#media.volumeAvailability;
		return {
			...super.getState(),
			availability,
			hidden: availability !== "available"
		};
	}
};
//#endregion
export { VolumePopoverCore };

//# sourceMappingURL=core.js.map